<script lang="ts">
  import { page } from "$app/stores";

  import ky from "ky";
  import { ChevronDown, PlusCircle } from "lucide-svelte";
  import { createEventDispatcher } from "svelte";

  import useSWR from "$lib/swr";
  import Dropdown from "$lib/ui/system/Dropdown.svelte";
  import DropdownItem from "$lib/ui/system/DropdownItem.svelte";
  import DropdownItemGroup from "$lib/ui/system/DropdownItemGroup.svelte";
  import type { WorkspaceDescription } from "~proto/modal_server/proto/public_api";

  const dispatch = createEventDispatcher<{ switch: string }>();

  export let workspace: string;
  export let environment: string;

  const { data: workspaceInfo, update: updateWorkspace } =
    useSWR<WorkspaceDescription>();
  $: updateWorkspace(`/api/workspaces/${workspace}`);

  function getEnvironmentHref(currentPath: string, environment: string) {
    const components = currentPath.split("/").slice(1);
    const keepFullPath = components[0] === "terms";

    if (keepFullPath) {
      components[2] = encodeURIComponent(environment);
      return `/${components.join("/")}`;
    } else {
      return `/${components[0]}/${workspace}/${encodeURIComponent(environment)}`;
    }
  }
</script>

<Dropdown>
  <button slot="button" class="btn w-full text-white py-1.5 px-2 gap-x-2">
    <span
      class="font-medium text-base whitespace-nowrap overflow-hidden text-ellipsis"
      >{environment}</span
    >
    <ChevronDown size={20} class="text-zinc-500" />
  </button>

  <DropdownItemGroup>
    {#each ($workspaceInfo?.environmentNames ?? []).toSorted() as environmentName}
      <DropdownItem
        class="w-44 sm:w-56"
        selected={environmentName === environment}
        href={getEnvironmentHref($page.url.pathname, environmentName)}
        on:click={(event) => {
          // implementing this for playground, where we want to switch envs without navigating to /apps
          const shouldContinue = dispatch("switch", environmentName, {
            cancelable: true,
          });
          if (!shouldContinue) {
            event.preventDefault();
            ky.post(`/api/user/last-used-environment/${workspace}`, {
              json: { environment: environmentName },
            });
          }
        }}
      >
        {environmentName}
      </DropdownItem>
    {/each}
  </DropdownItemGroup>

  <hr />

  <DropdownItemGroup>
    <DropdownItem
      href="/docs/reference/cli/environment#modal-environment-create"
      newTab
    >
      <PlusCircle size={20} class="text-zinc-400" slot="icon" />
      Create environment
    </DropdownItem>
  </DropdownItemGroup>
</Dropdown>
